export const pastEvents = [
  {
    id: 1,
    school: 'Eklavya Model Residential School Lahaul (EMRS)',
    city: 'Udaipur',
    state: 'Himachal Pradesh',
    date: 'November 4, 2025',
    participants: '50 students',
    description: 'We conducted an engaging environmental awareness quiz competition at EMRS Lahaul, testing students\' knowledge on climate change, biodiversity, and sustainable practices. The event was met with great enthusiasm from both students and faculty.',
    highlights: [
      'Interactive quiz format with 25 questions',
      'Focus on environmental conservation and sustainability',
      'Certificate distribution to all participants',
      'Engaging discussions on climate action'
    ],
    images: [
      '/images/events/emrs/emrs1.jpeg',
      '/images/events/emrs/emrs2.jpeg',
      '/images/events/emrs/emrs3.jpeg',
    ]
  },
  {
    id: 2,
    school: 'PM Shri School Jawahar Navodya Vidyalaya Lari',
    city: 'Tabo',
    state: 'Himachal Pradesh',
    date: 'November 13, 2025',
    participants: '49 students',
    description: 'We organized an exciting environmental awareness quiz at PM Shri School Jawahar Navodya Vidyalaya in the remote village of Lari, Tabo. The quiz challenged 49 bright students on topics including sustainable development, renewable energy, and conservation practices. The event fostered environmental consciousness in this high-altitude community, inspiring students to become eco-ambassadors in their region.',
    highlights: [
      'Comprehensive quiz covering sustainable living and eco-friendly practices',
      'Strong participation from students in a remote mountain region',
      'Interactive sessions on local environmental challenges and solutions',
      'Distribution of educational materials and certificates to all participants',
      'Emphasis on the role of youth in climate action'
    ],
    images: [
      '/images/events/JNV/jnv1.jpeg', 
      '/images/events/JNV/jnv2.jpeg',
      '/images/events/JNV/jnv3.jpeg',
      '/images/events/JNV/jnv4.jpeg',
      '/images/events/JNV/jnv5.jpeg',
    ]
  },
  {
    id: 3,
    school: 'Academic Heights World School',
    city: 'New Delhi',
    state: 'Delhi',
    date: 'November 18, 2025',
    participants: '30 students',
    description: 'Academic Heights World School in New Delhi welcomed our team for an interactive environmental quiz event. Thirty enthusiastic students participated, showcasing impressive knowledge on recycling, water conservation, and sustainable living. The event offered a platform for young minds to explore real-world environmental issues and seek innovative solutions for their city.',
    highlights: [
      'Engaging quiz sessions with creative rounds',
      'Focus on urban sustainability, recycling, and water conservation',
      'Participation certificates presented to all students',
      'Facilitated group discussion on local eco-friendly initiatives'
    ],
    images: [
      '/images/events/academic-heights/acad1.jpeg', 
      '/images/events/academic-heights/acad2.jpeg',
      '/images/events/academic-heights/acad3.jpeg',
    ]
  },
  {
    id: 4,
    school: 'Koormanchal Academy, Almora',
    city: 'Almora',
    state: 'Uttarakhand',
    date: 'November 18, 2025',
    participants: '5 students',
    description: 'Our outreach at Koormanchal Academy in Almora brought the message of environmental stewardship to a small but motivated group of five students. Despite the limited numbers, the quiz event sparked meaningful dialogue around biodiversity and the unique ecological challenges of the Himalayan region. The personalized session fostered lasting curiosity and an eagerness for further learning.',
    highlights: [
      'Personalized quiz and discussion event with every participant',
      'Special emphasis on biodiversity in the Himalayan region',
      'Encouraged creative thinking on local environmental protection',
      'Distributed certificates and resource materials to all students'
    ],
    images: [
      '/images/events/koormanchal/koormanchal1.jpeg', 
      '/images/events/koormanchal/koormanchal2.jpeg',
      '/images/events/koormanchal/koormanchal3.jpeg',
    ]
  },
  {
    id: 5,
    school: 'DAV Public School BSPS, Surangani',
    city: 'Chamba',
    state: 'Himachal Pradesh',
    date: 'November 21, 2025',
    participants: '36 students',
    description: 'DAV Public School BSPS in Surangani, Chamba hosted a dynamic environmental quiz for 36 enthusiastic students. The event focused on climate change, biodiversity, and practical steps for conservation relevant to the local community. The students actively collaborated, sharing innovative ideas for protecting Himachal\'s natural beauty and fostering a culture of environmental responsibility.',
    highlights: [
      'Collaborative quiz emphasizing teamwork and environmental awareness',
      'Discussions about local conservation strategies in Himachal',
      'All attendees received certificates for their participation',
      'Encouraged students to launch small-scale sustainability projects'
    ],
    images: [
      '/images/events/dav-surangani/dav1.jpg', 
      '/images/events/dav-surangani/dav2.jpg',
      '/images/events/dav-surangani/dav3.jpg',
    ]
  },
  {
    id: 6,
    school: "Gyan Vigyan Children's Academy, Hawalbagh",
    city: 'Almora',
    state: 'Uttarakhand',
    date: 'November 21, 2025',
    participants: '49 students',
    description: 'At Gyan Vigyan Children\'s Academy in Hawalbagh, Almora, the quiz engaged 49 students in lively learning about Uttarakhand\'s unique ecosystems. The event encouraged creative thinking about waste management, forest conservation, and the importance of water resources in hill regions. Students left motivated to implement eco-friendly habits in their daily lives.',
    highlights: [
      'Focused on sustainability and conservation in Himalayan hill regions',
      'Thought-provoking rounds on waste management and water resources',
      'Certificates awarded to all young participants',
      'Sparked student pledges to protect the environment at home and in the community'
    ],
    images: [
      '/images/events/gyan-vigyan/gyan1.jpg',
      '/images/events/gyan-vigyan/gyan2.jpg',
      '/images/events/gyan-vigyan/gyan3.jpg',
      '/images/events/gyan-vigyan/gyan4.jpg',
    ]
  },
  {
    id: 7,
    school: 'Poorna Prajna High School',
    city: 'Mumbai',
    state: 'Maharashtra',
    date: 'November 24, 2025',
    participants: '37 students',
    description: 'Poorna Prajna High School in Mumbai hosted an interactive quiz for 37 students, emphasizing urban environmental challenges and solutions. Topics included air pollution, marine conservation, and sustainable transport. The event inspired students to brainstorm ways they can contribute to making Mumbai cleaner and greener.',
    highlights: [
      'Quiz focused on urban ecology and sustainable transport',
      'Engaging conversations about pollution and clean city initiatives',
      'Recognition certificates given to every participant',
      'Motivated students to join and organize green activities in their neighborhoods'
    ],
    images: [
      '/images/events/pphs/pphs1.jpeg',
      '/images/events/pphs/pphs2.jpeg',
      '/images/events/pphs/pphs3.jpeg',
      '/images/events/pphs/pphs4.jpeg',
    ]
  },
  {
    id: 8,
    school: 'EMRS Nichar',
    city: 'Nichar',
    state: 'Himachal Pradesh',
    date: 'November 21, 2025',
    participants: '42 students',
    description: 'EMRS Nichar welcomed our team for an inspiring environmental quiz event in Himachal\'s mountainous heartland. Forty-two students participated enthusiastically, learning about biodiversity, climate resilience, and practical conservation efforts suited for their hill region. The quiz encouraged peer collaboration and helped foster a strong sense of ecological responsibility within the student community.',
    highlights: [
      'Interactive quiz encouraging teamwork and sharing of ideas',
      'Special focus on biodiversity and climate resilience in mountain ecosystems',
      'Distribution of participation certificates and eco-awareness materials',
      'Students developed action points for conservation in their local surroundings'
    ],
    images: [
      '/images/events/emrs-nichar/emrs1.jpg', 
      '/images/events/emrs-nichar/emrs2.jpg',
      '/images/events/emrs-nichar/emrs3.jpg',
    ]
  },
  {
    id: 9,
    school: 'Salwan Public School, Mayur Vihar',
    city: 'Mayur Vihar',
    state: 'Delhi',
    date: 'November 28, 2025',
    participants: '43 students',
    description: 'Salwan Public School in Mayur Vihar hosted an energetic quiz event focused on urban environmental issues. Forty-three students participated, tackling questions on sustainable living, pollution control, and city-based conservation strategies. The event inspired lively debates and creative problem-solving, motivating students to pursue eco-friendly practices in their daily lives and neighborhoods.',
    highlights: [
      'Stimulating quiz sessions centered on urban sustainability',
      'Debates and discussions on local environmental challenges',
      'Certificates presented to all student participants',
      'Encouraged real-world solutions for cleaner, greener city living'
    ],
    images: [
      '/images/events/salwan/salwan1.jpg', 
      '/images/events/salwan/salwan2.jpg',
      '/images/events/salwan/salwan3.jpg',
    ]
  },
  {
    id: 10,
    school: 'Cygnus High World School',
    city: 'Ambala',
    state: 'Haryana',
    date: 'December 1, 2025',
    participants: '49 students',
    description: 'Cygnus High World School in Ambala hosted an engaging environmental awareness quiz that brought together 49 enthusiastic students. The event focused on critical topics including climate action, pollution control, and sustainable development practices relevant to urban and semi-urban communities. Students actively participated in thought-provoking discussions, demonstrating their commitment to environmental stewardship.',
    highlights: [
      'Interactive quiz covering climate change, pollution, and sustainability',
      'Strong student engagement with creative problem-solving approaches',
      'Emphasis on practical environmental solutions for local communities',
      'Certificates and recognition awarded to all participants',
      'Inspired students to take environmental initiatives in their school and homes'
    ],
    images: [
      '/images/events/cygnus/cygnus1.jpg',
      '/images/events/cygnus/cygnus2.jpg',
      '/images/events/cygnus/cygnus3.jpg',
      '/images/events/cygnus/cygnus4.jpg',
    ]
  },
  {
    id: 11,
    school: 'Himalaya Public Senior Secondary School',
    city: 'Rohini',
    state: 'Delhi',
    date: 'December 4, 2025',
    participants: '29 students',
    description: 'Himalaya Public Senior Secondary School in Rohini welcomed our team for an engaging environmental awareness quiz. Twenty-nine dedicated students participated, exploring topics such as renewable energy, waste management, and sustainable urban living. The event sparked meaningful conversations about practical environmental solutions that students can implement in their daily lives and communities.',
    highlights: [
      'Comprehensive quiz on renewable energy and urban sustainability',
      'Active student participation with insightful questions and discussions',
      'Focus on practical eco-friendly solutions for city environments',
      'All participants received certificates of participation',
      'Encouraged students to become environmental advocates in their neighborhoods'
    ],
    images: [
      '/images/events/hpsss/hpsss1.jpg',
      '/images/events/hpsss/hpsss2.jpg',
      '/images/events/hpsss/hpsss3.jpg',
    ]
  },
  {
    id: 12,
    school: 'Akal Academy Ajitsar, Ratia',
    city: 'Ratia',
    state: 'Haryana',
    date: 'December 4, 2025',
    participants: '25 students',
    description: 'Akal Academy Ajitsar in Ratia, Haryana hosted a vibrant environmental quiz event with 25 enthusiastic students. The quiz covered essential topics including biodiversity conservation, water conservation, and sustainable agricultural practices relevant to rural communities. Students demonstrated remarkable environmental awareness and a strong commitment to protecting natural resources in their region.',
    highlights: [
      'Interactive quiz emphasizing biodiversity and water conservation',
      'Discussions on sustainable farming practices for rural communities',
      'Strong engagement from students with creative environmental ideas',
      'Certificates and educational resources distributed to all participants',
      'Motivated students to initiate local conservation projects'
    ],
    images: [
      '/images/events/akal/akal1.jpeg',
      '/images/events/akal/akal2.jpeg',
    ]
  },
  {
    id: 13,
    school: 'Mayoor School',
    city: 'Noida',
    state: 'Uttar Pradesh',
    date: 'December 5, 2025',
    participants: '42 students',
    description: 'Mayoor School in Noida hosted an environmental awareness quiz with 42 enthusiastic students. The quiz encouraged students to think critically about conservation, responsible resource use, and everyday eco-friendly habits.',
    highlights: [
      'Interactive environmental quiz for middle and senior school students',
      'Questions focused on conservation, waste management, and climate awareness',
      'Students discussed how to adopt greener habits at home and in school',
      'Participation certificates given to all student participants'
    ],
    images: [
      '/images/events/mayoor/1.jpeg',
      '/images/events/mayoor/2.jpeg',
      '/images/events/mayoor/3.jpeg',
    ]
  },
  {
    id: 14,
    school: 'DAV Public School, ECL, Jhanjra',
    city: 'Jhanjra',
    state: 'West Bengal',
    date: 'December 5, 2025',
    participants: '25 students',
    description: 'DAV Public School, ECL, Jhanjra organized a focused environmental quiz for 25 students. The event highlighted local issues such as air and water pollution around mining areas and empowered students to think about sustainable solutions.',
    highlights: [
      'Quiz rounds on pollution, biodiversity, and local environmental challenges',
      'Encouraged students to link global climate issues with their local context',
      'Students shared ideas for cleaner surroundings and responsible resource use',
      'All participating students received appreciation certificates'
    ],
    images: [
      '/images/events/dav-jhanjra/dav1.jpg',
      '/images/events/dav-jhanjra/dav2.jpg',
      '/images/events/dav-jhanjra/dav3.jpg',
    ]
  },
  {
    id: 15,
    school: 'Countrywide Public School',
    city: 'Garur',
    state: 'Uttarakhand',
    date: 'December 8, 2025',
    participants: '12 students',
    description: 'Countrywide Public School in Garur, Uttarakhand conducted an intimate environmental quiz with 12 motivated students. The quiz emphasized mountain ecosystems, water conservation, and protecting local biodiversity in the Himalayan region.',
    highlights: [
      'Discussion-based quiz focusing on Himalayan ecology and water security',
      'Students reflected on safeguarding forests, rivers, and local wildlife',
      'Emphasis on individual responsibility in fragile mountain environments',
      'Certificates awarded to all participants for their enthusiastic involvement'
    ],
    images: [
      '/images/events/countrywide/countrywide1.jpeg',
      '/images/events/countrywide/countrywide2.jpeg',
      '/images/events/countrywide/countrywide3.jpeg',
    ]
  },
  {
    id: 16,
    school: 'DAV Public School, Midnapore',
    city: 'Midnapore',
    state: 'West Bengal',
    date: 'December 9, 2025',
    participants: '35 students',
    description: 'DAV Public School in Midnapore hosted an engaging environmental quiz with 35 students. The sessions explored topics like forests, wildlife protection, and sustainable lifestyles, inspiring students to become ambassadors for nature in their communities.',
    highlights: [
      'Multi-round quiz on forests, wildlife, and sustainable living',
      'Students answered rapid-fire and situation-based questions on conservation',
      'Reinforced the importance of everyday eco-friendly choices',
      'All participants received certificates and encouragement to lead green initiatives'
    ],
    images: [
      '/images/events/dav-midnapore/dav1.jpeg',
      '/images/events/dav-midnapore/dav2.jpeg',
      '/images/events/dav-midnapore/dav3.jpeg',
    ]
  },
  {
    id: 17,
    school: 'Sachdeva Public School',
    city: 'Pitampura',
    state: 'Delhi',
    date: 'December 9, 2025',
    participants: '39 students',
    description: 'Sachdeva Public School in Pitampura conducted a dynamic environmental quiz with 39 students. The event focused on urban sustainability, waste segregation, and climate responsibility, motivating students to champion green practices in their school and homes.',
    highlights: [
      'Thought-provoking quiz on urban sustainability and waste management',
      'Group discussions on reducing plastic use and conserving resources',
      'Students pledged to adopt and promote eco-friendly habits',
      'Certificates and recognition given to all quiz participants'
    ],
    images: [
      '/images/events/sachdeva/sachdeva1.jpeg',
      '/images/events/sachdeva/sachdeva2.jpeg',
      '/images/events/sachdeva/sachdeva3.jpeg',
    ]
  },
  {
    id: 18,
    school: 'Vidya Bharati School',
    city: 'Delhi',
    state: 'Delhi',
    date: 'December 10, 2025',
    participants: '50 students',
    description: 'Vidya Bharati School in Delhi organised a vibrant environmental quiz for 50 students, centering on climate change, pollution control, and responsible citizenship toward nature.',
    highlights: [
      'Multi-round quiz on climate change and pollution control',
      'Students shared ideas on reducing carbon footprint and plastic waste',
      'Encouraged collaborative problem-solving for local environmental issues',
      'All participants received certificates and appreciation for active participation'
    ],
    images: [
      '/images/events/vidya-bharati/1.jpeg',
      '/images/events/vidya-bharati/2.jpeg',
      '/images/events/vidya-bharati/3.jpeg'
    ]
  },
  {
    id: 19,
    school: 'Gita Girls Senior Secondary School',
    city: 'Kurukshetra',
    state: 'Haryana',
    date: 'December 11, 2025',
    participants: '47 students',
    description: 'Gita Girls Senior Secondary School in Kurukshetra conducted an inspiring quiz with 47 students, focusing on river conservation, soil health, and traditional eco-friendly practices.',
    highlights: [
      'Quiz segments on river conservation and soil protection',
      'Students related environmental concepts to local agricultural practices',
      'Discussions on reviving traditional eco-friendly habits',
      'Certificates awarded to participants for their proactive engagement'
    ],
    images: [
      '/images/events/gita-girls/gita1.jpeg',
      '/images/events/gita-girls/gita2.jpeg'
    ]
  },
  {
    id: 20,
    school: 'Maharishi Vidya Mandir Public School, Nadaun',
    city: 'Nadaun',
    state: 'Himachal Pradesh',
    date: 'December 11, 2025',
    participants: '41 students',
    description: 'Maharishi Vidya Mandir Public School, Nadaun organised an environmental quiz with 41 students, emphasizing hill ecology, waste management, and conservation of local flora and fauna.',
    highlights: [
      'Focused quiz rounds on hill ecology and local biodiversity',
      'Students explored ways to reduce waste in school and community',
      'Emphasis on protecting nearby forests and river systems',
      'All participants received certificates recognising their interest in nature'
    ],
    images: [
      '/images/events/mvm/1.jpg',
      '/images/events/mvm/2.jpg',
      '/images/events/mvm/3.jpg'
    ]
  },
  {
    id: 21,
    school: 'Prince Public School',
    city: 'Delhi',
    state: 'Delhi',
    date: 'December 11, 2025',
    participants: '40 students',
    description: 'Prince Public School in Delhi held an energetic environmental quiz with 40 students, covering air quality, urban greenery, and the role of students in improving city environments.',
    highlights: [
      'Questions on air pollution, green spaces, and clean transport',
      'Students proposed ideas for greener, cleaner neighbourhoods',
      'Activity-based learning to connect theory with real urban issues',
      'Certificates distributed to all participants as motivation to act green'
    ],
    images: [
      '/images/events/prince/1.jpeg',
      '/images/events/prince/2.jpeg',
      '/images/events/prince/3.jpeg'
    ]
  },
  {
    id: 22,
    school: 'Delhi Heritage School',
    city: 'Delhi',
    state: 'Delhi',
    date: 'December 16, 2025',
    participants: '37 students',
    description: 'Delhi Heritage School conducted a thoughtful environmental quiz with 37 students, linking heritage conservation with environmental protection and sustainable development.',
    highlights: [
      'Quiz connected cultural heritage with environmental stewardship',
      'Students discussed preserving monuments, trees, and public spaces',
      'Reinforced the link between history, culture, and sustainability',
      'Participants received certificates and encouragement to lead eco-clubs'
    ],
    images: [
      '/images/events/delhi-heritage/1.jpg',
      '/images/events/delhi-heritage/2.jpg',
      '/images/events/delhi-heritage/3.jpg'
    ]
  },
  {
    id: 23,
    school: 'Alpine Public School',
    city: 'Nalagarh',
    state: 'Himachal Pradesh',
    date: 'December 18, 2025',
    participants: '48 students',
    description: 'Alpine Public School in Nalagarh organised a spirited environmental quiz with 48 students, encouraging awareness about local ecology, waste reduction, and responsible lifestyle choices.',
    highlights: [
      'Quiz rounds on local ecology, pollution, and climate awareness',
      'Students discussed practical steps to reduce waste in school and at home',
      'Emphasis on protecting hills, rivers, and biodiversity around Nalagarh',
      'Certificates and appreciation given to all student participants'
    ],
    images: [
      '/images/events/alpine/1.jpeg',
      '/images/events/alpine/2.jpeg',
      '/images/events/alpine/3.jpeg'
    ]
  },
  {
    id: 24,
    school: 'DAV Public School Airoli',
    city: 'Navi Mumbai',
    state: 'Maharashtra',
    date: 'December 20, 2025',
    participants: '37 students',
    description: 'A spirited environmental quiz was conducted at DAV Public School, Airoli with 37 students. The event highlighted coastal biodiversity, water conservation, and the role of young citizens in reducing plastic pollution.',
    highlights: [
      'Quiz segments focused on marine life and mangrove conservation',
      'Students shared innovative ideas for community-level water recycling',
      'Emphasis on the "Zero Waste" lifestyle and sustainable daily habits',
      'Participants received certificates and were encouraged to lead eco-club activities'
    ],
    images: [
      '/images/events/dav-airoli/1.jpeg',
      '/images/events/dav-airoli/2.jpeg'
    ]
  },
   {
  id: 25,
  school: 'B.D. Academy',
  city: 'Amarpur',
  state: 'Bihar',
  date: 'December 20, 2025',
  participants: '45 students',
  description: 'B.D. Academy in Amarpur hosted an engaging environmental quiz bringing together 45 enthusiastic students. The event highlighted pressing ecological concerns of Bihar\'s rural heartland, including river conservation, soil health, and sustainable land use. Students demonstrated remarkable curiosity and commitment toward understanding and addressing local environmental issues.',
  highlights: [
    'Quiz focused on river conservation and soil health in Bihar',
    'Students engaged with topics on sustainable land use and rural ecology',
    'Interactive discussions on local environmental challenges and community solutions',
    'Certificates distributed to all participants for their enthusiasm and environmental awareness'
  ],
  images: [
    '/images/events/bd-academy/1.jpg',
    '/images/events/bd-academy/2.jpg',
  ]
},
  {
    id: 26,
    school: 'DAV BR Public School',
    city: 'Bina',
    state: 'Madhya Pradesh',
    date: 'December 23, 2025',
    participants: '48 students',
    description: 'DAV BR Public School in Bina organised a highly interactive environmental quiz for 48 students. The session focused on the importance of industrial sustainability, clean energy, and protecting the local ecosystem.',
    highlights: [
      'Deep dive into renewable energy sources and their benefits',
      'Interactive session on industrial waste management and its impact',
      'Students discussed ways to increase green cover in urban areas',
      'All 48 participants were recognized with certificates for their proactive learning'
    ],
    images: [
      '/images/events/dav-br/1.jpeg',
      '/images/events/dav-br/2.jpeg'
    ]
  },
  {
    id: 27,
    school: "St. Xavier's High School",
    city: 'Cuttack',
    state: 'Odisha',
    date: 'January 6, 2026',
    participants: '49 students',
    description: "St. Xavier's High School in Cuttack kicked off the new year with an engaging environmental quiz for 49 students. The event explored topics ranging from wetland preservation to climate resilience and traditional conservation methods.",
    highlights: [
      'Focused discussion on the preservation of local wetlands and water bodies',
      'Students proposed strategies for local-level climate adaptation',
      'Explored the link between cultural heritage and nature conservation',
      'All participating students were awarded certificates for their enthusiastic participation'
    ],
    images: [
      '/images/events/stxhs/1.jpg',
      '/images/events/stxhs/2.jpg',
      '/images/events/stxhs/3.jpg'
    ]
  },
  {
    id: 28,
    school: 'Assam Rifles Public School, Mantripukhri',
    city: 'Imphal',
    state: 'Manipur',
    date: 'January 12, 2026',
    participants: '13 students',
    description: 'Assam Rifles Public School in Mantripukhri, Imphal hosted an intimate environmental awareness quiz with 13 dedicated students. The event focused on the unique biodiversity of Northeast India, conservation challenges in the region, and sustainable practices relevant to Manipur\'s fragile ecosystems. Students engaged in meaningful discussions about protecting local flora and fauna while addressing environmental issues specific to the hilly terrain.',
    highlights: [
      'Focused quiz on Northeast India\'s biodiversity and endemic species',
      'Discussion on conservation challenges in mountainous regions',
      'Students explored sustainable practices for hill communities',
      'Certificates distributed to all participants for their commitment to environmental learning'
    ],
    images: [
      '/images/events/assam-rifles/1.jpeg',
      '/images/events/assam-rifles/2.jpeg',
    ]
  },
  {
    id: 29,
    school: 'AGPN Convent & ER School',
    city: 'Purulia',
    state: 'West Bengal',
    date: 'January 13, 2026',
    participants: '49 students',
    description: 'AGPN Convent & ER School in Purulia organized a comprehensive environmental quiz with 49 enthusiastic students. The event covered topics including water conservation, soil erosion prevention, and sustainable agricultural practices relevant to West Bengal\'s semi-arid regions. Students demonstrated remarkable awareness about local environmental challenges and proposed innovative solutions for their community.',
    highlights: [
      'Interactive quiz emphasizing water conservation and soil protection',
      'Focus on sustainable agriculture in semi-arid regions',
      'Students shared creative ideas for rainwater harvesting and erosion control',
      'All participants received certificates recognizing their environmental consciousness'
    ],
    images: [
      '/images/events/agpn/1.jpeg',
      '/images/events/agpn/2.jpeg',
      '/images/events/agpn/3.jpeg',
    ]
  },
  {
    id: 30,
    school: 'DAV Public School, Nava Raipur',
    city: 'Raipur',
    state: 'Chhattisgarh',
    date: 'January 16, 2026',
    participants: '16 students',
    description: 'DAV Public School in Nava Raipur conducted a focused environmental quiz with 16 motivated students. The session explored urban planning and sustainability, forest conservation in Chhattisgarh, and the importance of protecting tribal knowledge about environmental management. The intimate setting allowed for in-depth discussions and personalized engagement with each participant.',
    highlights: [
      'Quiz on sustainable urban development and green city initiatives',
      'Discussion about forest conservation and tribal environmental wisdom',
      'Personalized interaction allowing deeper exploration of topics',
      'Certificates awarded to all students for their active participation'
    ],
    images: [
      '/images/events/dav-raipur/1.jpg',
      '/images/events/dav-raipur/2.jpg',
      '/images/events/dav-raipur/3.jpg',
    ]
  },
  {
    id: 31,
    school: 'DAV Public School, Badshahpur',
    city: 'Samana',
    state: 'Punjab',
    date: 'January 17, 2026',
    participants: '29 students',
    description: 'DAV Public School in Badshahpur, Samana hosted an engaging environmental quiz for 29 students. The event highlighted agricultural sustainability, water table depletion issues in Punjab, and eco-friendly farming techniques. Students actively discussed the environmental impact of intensive farming and explored solutions for sustainable agricultural practices in their region.',
    highlights: [
      'Comprehensive quiz on agricultural sustainability and water conservation',
      'Focus on Punjab\'s groundwater depletion and sustainable farming solutions',
      'Students proposed organic farming methods and crop diversification strategies',
      'All participants received certificates for their proactive environmental engagement'
    ],
    images: [
      '/images/events/dav-badshahpur/1.jpg',
      '/images/events/dav-badshahpur/2.jpg',
      '/images/events/dav-badshahpur/3.jpg',
    ]
  },
  {
    id: 32,
    school: 'DAV Public School, Tanda',
    city: 'Tanda',
    state: 'Uttar Pradesh',
    date: 'January 19, 2026',
    participants: '20 students',
    description: 'DAV Public School in Tanda organized an impactful environmental quiz with 20 students. The event focused on river pollution, waste management in small towns, and the importance of preserving local water bodies. Students engaged in thoughtful discussions about practical steps they can take to protect their environment and promote sustainable living in their community.',
    highlights: [
      'Quiz addressing river pollution and local water body conservation',
      'Discussion on effective waste management for small-town communities',
      'Students developed action plans for cleaner neighborhoods',
      'Certificates presented to all participants encouraging continued environmental stewardship'
    ],
    images: [
      '/images/events/dav-tanda/1.jpeg',
      '/images/events/dav-tanda/2.jpeg',
      '/images/events/dav-tanda/3.jpeg',
    ]
  },
  {
    id: 33,
    school: 'Guru Nanak Dev DAV Public School, Bhikhiwind',
    city: 'Bhikhiwind',
    state: 'Punjab',
    date: 'January 20, 2026',
    participants: '50 students',
    description: 'Guru Nanak Dev DAV Public School in Bhikhiwind conducted a highly engaging environmental quiz with 50 students. The event emphasized sustainable agriculture, water conservation in Punjab\'s agricultural belt, and reducing chemical pesticide use. Students demonstrated impressive knowledge about environmental challenges and showcased their commitment to implementing eco-friendly practices.',
    highlights: [
      'Interactive quiz on sustainable farming and organic agriculture',
      'Focus on water conservation strategies for agricultural communities',
      'Discussion about alternatives to chemical pesticides and fertilizers',
      'All 50 participants received certificates celebrating their environmental awareness'
    ],
    images: [
      '/images/events/gnd-bhikhiwind/1.jpg',
      '/images/events/gnd-bhikhiwind/2.jpg',
      '/images/events/gnd-bhikhiwind/3.jpg',
    ]
  },
  {
    id: 34,
    school: 'Babu Brish Bhan DAV Public School, Moonak',
    city: 'Moonak',
    state: 'Punjab',
    date: 'January 20, 2026',
    participants: '44 students',
    description: 'Babu Brish Bhan DAV Public School in Moonak hosted a dynamic environmental quiz with 44 enthusiastic students. The event covered topics including groundwater conservation, sustainable crop practices, and air quality management in agricultural regions. Students actively participated in discussions about balancing agricultural productivity with environmental protection.',
    highlights: [
      'Engaging quiz on groundwater management and sustainable agriculture',
      'Students explored solutions for air pollution from crop burning',
      'Interactive sessions on soil health and crop rotation benefits',
      'Certificates awarded to all participants for their environmental commitment'
    ],
    images: [
      '/images/events/bbb-moonak/1.jpeg',
      '/images/events/bbb-moonak/2.jpeg',
      '/images/events/bbb-moonak/3.jpeg',
    ]
  },
  {
    id: 35,
    school: 'Aman Academy',
    city: 'Darbhanga',
    state: 'Bihar',
    date: 'January 20, 2026',
    participants: '42 students',
    description: 'Aman Academy in Darbhanga organized an inspiring environmental quiz with 42 students. The event focused on flood management, wetland conservation, and sustainable practices for Bihar\'s flood-prone regions. Students demonstrated keen awareness about local environmental challenges and proposed innovative solutions for climate adaptation and disaster preparedness.',
    highlights: [
      'Quiz emphasizing flood management and climate adaptation strategies',
      'Focus on protecting wetlands and water bodies in Bihar',
      'Students discussed community-based disaster preparedness measures',
      'All participants received certificates recognizing their environmental consciousness'
    ],
    images: [
      '/images/events/aman-academy/1.jpg',
      '/images/events/aman-academy/2.jpg',
      '/images/events/aman-academy/3.jpg',
    ]
  },
  {
    id: 36,
    school: 'DDB DAV Centenary Public School',
    city: 'Ferozepur',
    state: 'Punjab',
    date: 'January 21, 2026',
    participants: '25 students',
    description: 'DDB DAV Centenary Public School in Ferozepur conducted a focused environmental quiz with 25 students. The event highlighted border region ecology, water scarcity issues, and sustainable development practices. The intimate setting facilitated deep discussions about environmental protection and students\' role in promoting conservation in their communities.',
    highlights: [
      'Quiz on water scarcity and conservation in border regions',
      'Discussion about sustainable development in resource-limited areas',
      'Students proposed community-level water saving initiatives',
      'Certificates distributed to all participants for their dedication to environmental learning'
    ],
    images: [
      '/images/events/ddb-ferozepur/1.jpg',
      '/images/events/ddb-ferozepur/2.jpg',
      '/images/events/ddb-ferozepur/3.jpg',
    ]
  },
  {
  id: 37,
  school: 'Brainy Blooms Lecole International Senior Secondary CBSE School',
  city: 'Puducherry',
  state: 'Puducherry',
  date: 'January 21, 2026',
  participants: '49 students',
  description: 'Brainy Blooms Lecole International Senior Secondary CBSE School in Puducherry welcomed 49 spirited students for a vibrant environmental quiz. The event explored coastal ecosystem conservation, marine biodiversity, and climate resilience — topics deeply relevant to Puducherry\'s unique coastal geography. Students showed impressive awareness of both local and global environmental challenges.',
  highlights: [
    'Quiz centered on coastal ecosystems and marine biodiversity conservation',
    'Discussions on climate resilience and sustainable coastal living',
    'Students explored the environmental significance of Puducherry\'s mangroves and shoreline',
    'Certificates distributed to all participants for their enthusiasm and environmental awareness'
  ],
  images: [
    '/images/events/brainy-blooms/1.jpeg',
    '/images/events/brainy-blooms/2.jpeg',
    '/images/events/brainy-blooms/3.jpeg',
  ]
},
  {
    id: 38,
    school: 'Delhi Public Sr. Sec. School, Barmer',
    city: 'Barmer',
    state: 'Rajasthan',
    date: 'January 22, 2026',
    participants: '50 students',
    description: 'Delhi Public Sr. Sec. School in Barmer hosted an energetic environmental quiz with 50 students. The event focused on desert ecology, water conservation in arid regions, and sustainable practices for Rajasthan\'s challenging climate. Students showcased remarkable understanding of desert ecosystems and discussed innovative solutions for water scarcity and renewable energy adoption.',
    highlights: [
      'Comprehensive quiz on desert ecosystems and arid region conservation',
      'Focus on water harvesting techniques and drought management',
      'Discussion about solar energy potential in Rajasthan',
      'All 50 participants received certificates celebrating their environmental engagement'
    ],
    images: [
      '/images/events/dps-barmer/1.jpeg',
      '/images/events/dps-barmer/2.jpeg',
      '/images/events/dps-barmer/3.jpeg',
    ]
  },
  {
    id: 39,
    school: 'DAV Public School, Hamirpur',
    city: 'Hamirpur',
    state: 'Himachal Pradesh',
    date: 'January 22, 2026',
    participants: '20 students',
    description: 'DAV Public School in Hamirpur organized an intimate environmental quiz with 20 dedicated students. The event emphasized Himalayan ecology, watershed management, and conservation of hill biodiversity. Students engaged in meaningful discussions about protecting mountain ecosystems and adopting sustainable practices suited to their hilly terrain.',
    highlights: [
      'Focused quiz on Himalayan biodiversity and mountain ecosystems',
      'Discussion on watershed management and forest conservation',
      'Students explored sustainable tourism and its environmental impact',
      'Certificates awarded to all participants for their commitment to protecting hill ecology'
    ],
    images: [
      '/images/events/dav-hamirpur/1.jpeg',
      '/images/events/dav-hamirpur/2.jpeg',
      '/images/events/dav-hamirpur/3.jpeg',
    ]
  },
  {
    id: 40,
    school: 'Akal academy Chogawan',
    city: 'Amritsar',
    state: 'Punjab',
    date: 'January 27, 2026',
    participants: '50 students',
    description: 'Akal Academy Chogawan in Amritsar conducted a vibrant environmental quiz with 50 enthusiastic students. The event covered topics including water pollution in Punjab\'s rivers, sustainable agricultural practices, and air quality management. Students demonstrated excellent environmental awareness and proposed practical solutions for their community\'s environmental challenges.',
    highlights: [
      'Interactive quiz on river conservation and pollution control',
      'Focus on sustainable farming and reducing chemical inputs',
      'Discussion about air quality improvement measures',
      'All 50 participants received certificates for their active environmental engagement'
    ],
    images: [
      '/images/events/akal-chogawan/1.jpg',
      '/images/events/akal-chogawan/2.jpg',
      '/images/events/akal-chogawan/3.jpg',
    ]
  },
  {
    id: 41,
    school: 'Delhi Public School HRIT Campus',
    city: 'Ghaziabad',
    state: 'Uttar Pradesh',
    date: 'January 27, 2026',
    participants: '31 students',
    description: 'Delhi Public School HRIT Campus in Ghaziabad hosted an engaging environmental quiz with 31 students. The event focused on urban sustainability, air pollution in NCR region, and waste management strategies. Students actively participated in discussions about creating greener cities and implementing eco-friendly practices in their daily lives.',
    highlights: [
      'Quiz addressing urban environmental challenges in NCR',
      'Focus on air quality improvement and pollution mitigation',
      'Students proposed waste reduction and recycling initiatives',
      'Certificates presented to all participants for their environmental consciousness'
    ],
    images: [
      '/images/events/dps-hrit/1.jpeg',
      '/images/events/dps-hrit/2.jpeg',
      '/images/events/dps-hrit/3.jpeg',
    ]
  },
  {
    id: 42,
    school: "The Mother's International School",
    city: 'New Delhi',
    state: 'Delhi',
    date: 'January 28, 2026',
    participants: '48 students',
    description: "The Mother's International School in New Delhi organized an inspiring environmental quiz with 48 students. The event covered climate change, urban green spaces, and sustainable lifestyle choices. Students demonstrated impressive knowledge and engaged in thoughtful discussions about their role in creating a more sustainable future for Delhi and beyond.",
    highlights: [
      'Comprehensive quiz on climate action and urban sustainability',
      'Discussion about increasing green cover in urban Delhi',
      'Students shared ideas for reducing carbon footprint in daily life',
      'All participants received certificates recognizing their environmental commitment'
    ],
    images: [
      '/images/events/mothers-international/1.jpeg',
      '/images/events/mothers-international/2.jpeg',
      '/images/events/mothers-international/3.jpeg',
    ]
  },
  {
    id: 43,
    school: 'EMRS Guna',
    city: 'Guna',
    state: 'Madhya Pradesh',
    date: 'January 28, 2026',
    participants: '30 students',
    description: 'EMRS Guna in Madhya Pradesh conducted an interactive environmental quiz with 30 students. The event focused on forest conservation, wildlife protection, and sustainable practices for tribal communities. Students showcased their understanding of local ecosystems and discussed traditional environmental knowledge alongside modern conservation techniques.',
    highlights: [
      'Quiz emphasizing forest biodiversity and wildlife conservation',
      'Integration of traditional tribal knowledge with modern practices',
      'Discussion on sustainable livelihood options for forest communities',
      'Certificates awarded to all participants for their engagement'
    ],
    images: [
      '/images/events/emrs-guna/1.jpg',
      '/images/events/emrs-guna/2.jpg',
      '/images/events/emrs-guna/3.jpg',
    ]
  },
  {
    id: 44,
    school: 'Jagannath International School',
    city: 'New Delhi',
    state: 'Delhi',
    date: 'January 28, 2026',
    participants: '45 students',
    description: 'Jagannath International School in New Delhi hosted a dynamic environmental quiz with 45 students. The event covered urban ecology, pollution control, and sustainable development goals. Students actively engaged in discussions about practical environmental solutions and pledged to become environmental ambassadors in their school and community.',
    highlights: [
      'Collaborative quiz emphasizing teamwork and environmental awareness',
      'Discussions about local conservation strategies in Himachal',
      'All attendees received certificates for their participation',
      'Encouraged students to launch small-scale sustainability projects'
    ],
    images: [
      '/images/events/jagannath/1.jpeg',
      '/images/events/jagannath/2.jpeg',
      '/images/events/jagannath/3.jpeg',
    ]
  },
  {
    id: 45,
    school: 'JK Public School, Kathua',
    city: 'Kathua',
    state: 'Jammu and Kashmir',
   date: 'January 29, 2026',
   participants: '50 students',
   description: 'JK Public School in Kathua organized an engaging environmental quiz with 50 students. The event highlighted regional biodiversity, water conservation, and sustainable practices for Jammu\'s varied ecosystems. Students demonstrated excellent environmental knowledge and discussed ways to protect their region\'s natural heritage while promoting sustainable development.',
   highlights: [
     'Comprehensive quiz on regional ecology and biodiversity conservation',
     'Discussion on water resource management and river conservation',
     'Students explored sustainable tourism and its environmental benefits',
      'All 50 participants received certificates for their environmental enthusiasm'
   ],
   images: [
    '/images/events/jk-kathua/1.jpg',
    '/images/events/jk-kathua/2.jpg',
     '/images/events/jk-kathua/3.jpg',
    ]
  },
  {
   id: 46,
   school: 'Jhabban Lal DAV Public School',
   city: 'New Delhi',
    state: 'Delhi',
   date: 'January 29, 2026',
   participants: '40 students',
   description: 'Jhabban Lal DAV Public School in New Delhi conducted a spirited environmental quiz with 40 students. The event focused on air quality, waste management, and sustainable urban living. Students actively participated in discussions about reducing their environmental footprint and creating healthier, greener neighborhoods in the capital city.',
   highlights: [
    'Quiz addressing Delhi\'s air quality and pollution challenges',
     'Focus on waste segregation and recycling initiatives',
      'Students proposed community-level environmental improvement projects',
     'Certificates distributed to all participants for their proactive environmental engagement'
    ],
    images: [
     '/images/events/jhabban-lal/1.jpg',
     '/images/events/jhabban-lal/2.jpg',
     '/images/events/jhabban-lal/3.jpg',
    ]
  },
  {
    id: 47,
    school: 'The Mann School',
    city: 'New Delhi',
    state: 'Delhi',
    location: 'New Delhi, Delhi',
    date: 'January 29, 2026',
    participants: '44 students',
    description: 'The Mann School in New Delhi hosted an interactive environmental quiz with 44 students. The event covered climate change, sustainable consumption, and urban environmental challenges. Students demonstrated strong environmental awareness and engaged in meaningful discussions about implementing sustainable practices in their school and homes.',
    highlights: [
      'Engaging quiz on climate action and sustainable living',
      'Discussion about reducing plastic use and promoting circular economy',
      'Students shared innovative ideas for green school initiatives',
     'All participants received certificates recognizing their environmental consciousness'
    ],
    images: [
     '/images/events/mann-school/1.jpeg',
    '/images/events/mann-school/2.jpeg',
     '/images/events/mann-school/3.jpeg',
    ]
  },
  {
    id: 48,
    school: 'DAV Model School, Sankarpur',
    city: 'Durgapur',
    state: 'West Bengal',
    date: 'January 31, 2026',
    participants: '23 students',
    description: 'DAV Model School in Sankarpur, Durgapur organized a focused environmental quiz with 23 students. The event emphasized industrial pollution management, air and water quality, and sustainable practices for industrial towns. Students discussed balancing industrial development with environmental protection and proposed community-level conservation initiatives.',
    highlights: [
     'Quiz on environmental challenges in industrial areas',
     'Focus on air and water pollution control measures',
     'Students explored green technology and cleaner production methods',
    'Certificates awarded to all participants for their environmental commitment'
    ],
    images: [
     '/images/events/dav-sankarpur/1.jpeg',
     '/images/events/dav-sankarpur/2.jpeg',
    '/images/events/dav-sankarpur/3.jpeg',
    ]
  },
  {
    id: 49,
    school: 'Holy Public School',
    city: 'Agra',
    state: 'Uttar Pradesh',
    date: 'February 2, 2026',
    participants: '45 students',
    description: 'Holy Public School in Agra conducted an inspiring environmental quiz with 45 students. The event focused on heritage conservation, pollution affecting monuments, and sustainable tourism. Students demonstrated keen awareness about protecting Agra\'s environment and historical treasures while discussing practical solutions for cleaner air and water in their city.',
    highlights: [
    'Interactive quiz linking heritage preservation with environmental protection',
    'Discussion on pollution\'s impact on historical monuments',
    'Students proposed sustainable tourism practices for Agra',
    'All 45 participants received certificates celebrating their environmental dedication'
    ],
    images: [
      '/images/events/holy-agra/1.jpeg',
     '/images/events/holy-agra/2.jpeg',
    '/images/events/holy-agra/3.jpeg',
    ]
  },
  {
    id: 50,
    school: 'Sukhjinder Memorial Public School',
    city: 'Gurdaspur',
    state: 'Punjab',
    date: 'February 3, 2026',
    participants: '17 students',
    description: 'Sukhjinder Memorial Public School in Gurdaspur organized an intimate environmental quiz with 17 dedicated students. The event covered water conservation, agricultural sustainability, and biodiversity protection in Punjab\'s border regions. The personalized setting allowed for in-depth discussions and meaningful engagement with each student about environmental challenges and solutions.',
    highlights: [
      'Comprehensive quiz covering sustainable living and eco-friendly practices',
      'Strong participation from students in a remote mountain region',
      'Interactive sessions on local environmental challenges and solutions',
      'Distribution of educational materials and certificates to all participants',
      'Emphasis on the role of youth in climate action'
    ],
    images: [
      '/images/events/sukhjinder/1.jpeg',
     '/images/events/sukhjinder/2.jpeg',
      '/images/events/sukhjinder/3.jpeg',
    ]
  },
 

{
  id: 51,
  school: 'Sainik School Mandsaur',
  city: 'Mandsaur',
  state: 'Madhya Pradesh',
  date: 'February 4, 2026',
  participants: '20 students',
  description: 'Sainik School Mandsaur organized a focused environmental quiz with 20 disciplined and attentive students. The event addressed environmental stewardship, forest conservation, and water resource management in the Malwa plateau region of Madhya Pradesh. The intimate setting encouraged thoughtful dialogue on the role of responsible citizens in protecting natural resources.',
  highlights: [
      'Engaging quiz sessions with creative rounds',
      'Focus on urban sustainability, recycling, and water conservation',
      'Participation certificates presented to all students',
      'Facilitated group discussion on local eco-friendly initiatives'
    ],
  images: [
    '/images/events/sainik-mandsaur/1.jpg',
    '/images/events/sainik-mandsaur/2.jpg',
  ]
},
{
  id: 52,
  school: 'Bal Bharati Public School, Nabinagar',
  city: 'Aurangabad',
  state: 'Bihar',
  date: 'February 5, 2026',
  participants: '32 students',
  description: 'Bal Bharati Public School in Nabinagar, Aurangabad hosted an enriching environmental quiz with 32 engaged students. The event brought focus to Bihar\'s agrarian environment, covering topics such as groundwater conservation, crop diversity, and sustainable farming practices. Students participated actively, reflecting a strong sense of environmental responsibility rooted in their local context.',
  highlights: [
      'Interactive quiz encouraging teamwork and sharing of ideas',
      'Special focus on biodiversity and climate resilience in mountain ecosystems',
      'Distribution of participation certificates and eco-awareness materials',
      'Students developed action points for conservation in their local surroundings'
    ],
  images: [
    '/images/events/bal-bharati-nabinagar/1.jpeg',
    '/images/events/bal-bharati-nabinagar/2.jpeg',
    '/images/events/bal-bharati-nabinagar/3.jpeg',
  ]
},
{
  id: 53,
  school: 'Army Public School Ranikhet',
  city: 'Ranikhet',
  state: 'Uttarakhand',
  date: 'February 9, 2026',
  participants: '22 students',
  description: 'Army Public School Ranikhet organized a focused environmental quiz with 22 disciplined and enthusiastic students nestled in the serene hills of Uttarakhand. The event highlighted the ecological significance of the Kumaon Himalayas, covering topics such as forest conservation, wildlife protection, and sustainable water management in mountain communities. The intimate setting encouraged thoughtful discussions on preserving the fragile highland environment.',
  highlights: [
      'Comprehensive quiz covering sustainable living and eco-friendly practices',
      'Strong participation from students in a remote mountain region',
      'Interactive sessions on local environmental challenges and solutions',
      'Distribution of educational materials and certificates to all participants',
      'Emphasis on the role of youth in climate action'
    ],
  images: [
    '/images/events/aps-ranikhet/1.jpg',
    '/images/events/aps-ranikhet/2.jpg',
    '/images/events/aps-ranikhet/3.jpg',
  ]
},
{
  id: 54,
  school: 'Ajmera Mukesh Nemichandbhai English Medium School',
  city: 'Indore',
  state: 'Madhya Pradesh',
  date: 'February 11, 2026',
  participants: '42 students',
  description: 'Ajmera Mukesh Nemichandbhai English Medium School in Indore hosted a lively environmental quiz with 42 enthusiastic students. The event addressed urban environmental challenges, including air quality, waste management, and green urban planning — issues directly relevant to one of Madhya Pradesh\'s fastest-growing cities. Students engaged with practical solutions and innovative ideas for a sustainable urban future.',
  highlights: [
      'Personalized quiz and discussion event with every participant',
      'Special emphasis on biodiversity in the Himalayan region',
      'Encouraged creative thinking on local environmental protection',
      'Distributed certificates and resource materials to all students'
    ],
  images: [
    '/images/events/ajmera-indore/1.jpeg',
    '/images/events/ajmera-indore/2.jpeg',
    '/images/events/ajmera-indore/3.jpeg',
  ]
},
{
  id: 55,
  school: 'Chanakya International School',
  city: 'Jalandhar',
  state: 'Punjab',
  date: 'February 18, 2026',
  participants: '19 students',
  description: 'Chanakya International School in Jalandhar organized an intimate yet impactful environmental quiz with 19 dedicated students. The event explored Punjab\'s environmental landscape, with particular attention to stubble burning, soil degradation, and the conservation of the Beas and Sutlej river systems. The focused group setting fostered meaningful conversations about actionable environmental solutions.',
  highlights: [
      'Interactive quiz encouraging teamwork and sharing of ideas',
      'Special focus on biodiversity and climate resilience in mountain ecosystems',
      'Distribution of participation certificates and eco-awareness materials',
      'Students developed action points for conservation in their local surroundings'
    ],
  images: [
    '/images/events/chanakya-jalandhar/1.jpg',
    '/images/events/chanakya-jalandhar/2.jpg',
    '/images/events/chanakya-jalandhar/3.jpg',
  ]
},
{
  id: 56,
  school: 'Dalhousie Public School',
  city: 'Dalhousie',
  state: 'Himachal Pradesh',
  date: 'March 16, 2026',
  participants: '50 students',
  description: 'Dalhousie Public School welcomed 50 enthusiastic students for a vibrant environmental quiz set amidst the scenic hills of Himachal Pradesh. The event delved into mountain ecosystem conservation, glacier health, deforestation, and the fragile ecology of the Western Himalayas. Students demonstrated exceptional awareness of how climate change is reshaping their highland environment and discussed community-driven conservation efforts.',
  highlights: [
      'Interactive quiz covering climate change, pollution, and sustainability',
      'Strong student engagement with creative problem-solving approaches',
      'Emphasis on practical environmental solutions for local communities',
      'Certificates and recognition awarded to all participants',
      'Inspired students to take environmental initiatives in their school and homes'
    ],
  images: [
    '/images/events/dalhousie-public/1.jpeg',
    '/images/events/dalhousie-public/2.jpeg',
    '/images/events/dalhousie-public/3.jpeg',
  ]
},
];

// Helper function to get unique states
export const getUniqueStates = () => {
  const states = pastEvents.map(event => event.state);
  return [...new Set(states)].sort();
};

// Helper function to filter events by state
export const filterEventsByState = (state) => {
  if (!state || state === 'all') return pastEvents;
  return pastEvents.filter(event => event.state === state);
};

// Helper function to get event count by state
export const getEventCountByState = () => {
  return pastEvents.reduce((acc, event) => {
    acc[event.state] = (acc[event.state] || 0) + 1;
    return acc;
  }, {});
};

// Helper function to filter by multiple states
export const filterEventsByStates = (states) => {
  if (!states || states.length === 0 || states.includes('all')) return pastEvents;
  return pastEvents.filter(event => states.includes(event.state));
};

// Helper function to get events by city
export const filterEventsByCity = (city) => {
  if (!city || city === 'all') return pastEvents;
  return pastEvents.filter(event => event.city.toLowerCase() === city.toLowerCase());
};
